<template>
  <div class="box8"></div>
</template>

<script>
export default {
  data() {
    return {};
  },
  methods: {},
};
</script>

<style lang="scss" scoped>
.box8 {
  position: relative;
  width: 100%;
  height: 312px;
  background: url("../../../assets/coursePage/media/box8/bgc.png") no-repeat;
  background-size: cover;
  background-position: center;
  overflow: hidden;
  box-sizing: border-box;
}
</style>
